
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4iTbK", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $9hBBk = parcelRequire("9hBBk");


var $7JKd3 = parcelRequire("7JKd3");

function $c818d579c2a95bd2$export$d2a66369b43f5d65({ onClose: onClose, onOptionSelect: onOptionSelect, onRemixFlowActiveChange: onRemixFlowActiveChange, isEphemeralViewVisible: isEphemeralViewVisible = false, skipThinkingTypes: skipThinkingTypes, options: options, subtitle: subtitle, presentation: presentation = 'modal', trigger: trigger, popupPlacement: popupPlacement, popupOffset: popupOffset, isPopupOpen: isPopupOpen = true, popupRepositionKey: popupRepositionKey }) {
    const [isThinking, setIsThinking] = (0, $42omo.useState)(false);
    const [selectedOptionType, setSelectedOptionType] = (0, $42omo.useState)();
    const handleOptionSelect = (0, $42omo.useCallback)((params)=>{
        if (!skipThinkingTypes?.has(params.type)) setIsThinking(true);
        setSelectedOptionType(params.type);
        onRemixFlowActiveChange?.(true);
        onOptionSelect?.(params);
    }, [
        onOptionSelect,
        onRemixFlowActiveChange,
        skipThinkingTypes
    ]);
    const handleStopThinking = (0, $42omo.useCallback)(()=>{
        setIsThinking(false);
        onRemixFlowActiveChange?.(false);
    }, [
        onRemixFlowActiveChange
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isThinking) return;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') handleStopThinking();
            }
        });
    }, [
        isThinking,
        handleStopThinking
    ]);
    // In popup mode, the trigger must always be rendered so the popup can anchor to it.
    // The popup content visibility is controlled by isPopupOpen.
    if (presentation === 'popup' && trigger) {
        const showThinkingBar = isThinking && !isEphemeralViewVisible;
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9hBBk.RemixPopup), {
                    isOpen: isPopupOpen && !isThinking,
                    onClose: onClose,
                    trigger: trigger,
                    placement: popupPlacement,
                    offset: popupOffset,
                    onOptionSelect: handleOptionSelect,
                    options: options,
                    subtitle: subtitle,
                    repositionKey: popupRepositionKey
                }),
                showThinkingBar && /*#__PURE__*/ (0, $l998X.jsx)((0, $7JKd3.RemixThinkingBar), {
                    onStop: handleStopThinking,
                    optionType: selectedOptionType
                })
            ]
        });
    }
    // Modal mode (default)
    // While thinking: show thinking bar only when ephemeral is not yet visible; otherwise show nothing
    if (isThinking) {
        if (!isEphemeralViewVisible) return /*#__PURE__*/ (0, $l998X.jsx)((0, $7JKd3.RemixThinkingBar), {
            onStop: handleStopThinking,
            optionType: selectedOptionType
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9hBBk.RemixOverlay), {
        onClose: onClose,
        onOptionSelect: handleOptionSelect,
        options: options,
        subtitle: subtitle
    });
}
module.exports["RemixContainer"] = $c818d579c2a95bd2$export$d2a66369b43f5d65;

});

parcelRegister("9hBBk", function(module, exports) {
$parcel$export(module.exports, "remixOverlayMessages", () => (parcelRequire("h9xA7")).default);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");


var $fzqvY = parcelRequire("fzqvY");


var $cO1el = parcelRequire("cO1el");


var $7642E = parcelRequire("7642E");


var $euUgw = parcelRequire("euUgw");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $gj7hi = parcelRequire("gj7hi");


var $5nBzc = parcelRequire("5nBzc");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $6xdDU = parcelRequire("6xdDU");


var $4Gau4 = parcelRequire("4Gau4");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $9EtP6 = parcelRequire("9EtP6");


var $3gadb = parcelRequire("3gadb");


var $hKEhS = parcelRequire("hKEhS");


var $ks59b = parcelRequire("ks59b");


var $h9xA7 = parcelRequire("h9xA7");


var $gCqjE = parcelRequire("gCqjE");

const $adb20307aac79bd1$var$headerOuterStyle = null;
const $adb20307aac79bd1$var$headerOuterMinimizedStyle = null;
const $adb20307aac79bd1$var$labsPositionStyle = null;
const $adb20307aac79bd1$var$headerIconWrapperStyle = null;
const $adb20307aac79bd1$var$headerIconWrapperMinimizedStyle = null; // 92px = space.300 (24px top padding) + 64px icon + 4px gap
const $adb20307aac79bd1$var$headerHeadingStyle = null; // left: 16px (space.200) + 48px icon + 8px gap = 72px
// top: vertically centered with 48px icon — icon center is at 16px + 24px = 40px,
// heading line-height ~24px, so top = 40px - 12px = 28px
const $adb20307aac79bd1$var$headerHeadingMinimizedStyle = null; // 120px = 92px heading top + ~28px heading height
const $adb20307aac79bd1$var$headerSubtitleStyle = null; // Hide subtitle in minimized state — fast fade out, delayed fade in handled by base style
const $adb20307aac79bd1$var$headerSubtitleMinimizedStyle = null;
const $adb20307aac79bd1$var$subtitleStyle = null; // 113px = 64px icon + 4px gap + ~28px heading + ~4px gap + ~13px subtitle
const $adb20307aac79bd1$var$headerSpacerStyle = null; // 48px = minimized icon height (no subtitle in minimized state)
const $adb20307aac79bd1$var$headerSpacerMinimizedStyle = null; // ── RemixSubTypeGrid styles ────────────────────────────────────────────────
const $adb20307aac79bd1$var$gridStyles = {
    grid: "_zulpu2gc _1e0c11p5 _yv0e16hb _1bsb1osq",
    tile: "_2rko1mok _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1wqb _bfhk1bhr _80omtlke _4cvx1j28 _irr319i6"
}; // ── RemixAccordionOption styles ────────────────────────────────────────────
const $adb20307aac79bd1$var$accordionStyles = {
    accordionWrapper: "_2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1osq",
    accordionHeader: "_2rko1mok _189eidpf _1rjcu2gc _1bsb1osq _4t3ickbl _1e0c1txw _4cvr1h6o _1bah1yb4 _bfhksm61 _bozgutpp _y4tiutpp _80omtlke _mizu1r31 _ra3xglyw _128m1o36",
    expandedContent: "_18zrutpp _85i5ze3t",
    pickForMeWrapper: "_18zr12x7 _1q5112x7 _85i512x7 _uwhke4h9 _15a5nqa1 _1i531l7x _1pfhutpp"
};
const $adb20307aac79bd1$var$accordionCollapsedStyle = null;
const $adb20307aac79bd1$var$accordionExpandedStyle = null;
const $adb20307aac79bd1$var$revealContentStyle = null;
const $adb20307aac79bd1$var$pickForMeButtonStyle = null; // ── RemixOverlay styles ────────────────────────────────────────────────────
const $adb20307aac79bd1$var$modalContentWrapperStyle = null; // ── RemixPopup styles ──────────────────────────────────────────────────────
const $adb20307aac79bd1$var$subtleSlideIn = null;
const $adb20307aac79bd1$var$popupEnterAnimationStyle = null;
const $adb20307aac79bd1$var$popupStyles = {
    contentWrapper: "_1reo15vq _18m915vq _2rko1mok _1e0c1txw _2lx21bp4 _1bsbnklw _bfhkhfxm",
    body: "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _2lx21bp4"
};
const $adb20307aac79bd1$var$scrollableBodyStyle = null;
const $adb20307aac79bd1$var$remixStyles = {
    describeInputBorderWrapper: "_1bsb1osq _uwhke4h9 _15a5nqa1 _1i531l7x",
    describeInputWrapper: "_1rjcutpp _18zrpxbi _1bsb1osq _bfhkhfxm",
    describePromptRow: "_zulp12x7 _1e0c1txw _2lx2vrvc _4cvresu3 _1bsb1osq",
    describeTextAreaWrapper: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf",
    modalBodyPadding: "_18zrpxbi _1q51ze3t _85i5pxbi",
    remixOptionsStack: "_1bsb1osq"
}; // ── RemixOverlayHeader ─────────────────────────────────────────────────────
function $adb20307aac79bd1$var$RemixOverlayHeader({ subtitle: subtitle, isMinimized: isMinimized = false }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const subtitleMessage = subtitle ?? (0, $h9xA7.default).subtitle; // Track minimized state changes to trigger the icon fade-out/fade-in animation.
    // When isMinimized changes, quickly fade out at the start, then fade back in
    // near the end of the 200ms position transition.
    const iconRef = (0, $42omo.useRef)(null);
    const prevMinimizedRef = (0, $42omo.useRef)(isMinimized);
    (0, $42omo.useEffect)(()=>{
        if (prevMinimizedRef.current !== isMinimized) {
            prevMinimizedRef.current = isMinimized;
            const el = iconRef.current;
            if (el) {
                // Gently fade out (uses the 100ms ease-out opacity transition from the base style)
                el.style.opacity = '0'; // Near the end of the 200ms position transition, fade back in
                const timer = setTimeout(()=>{
                    el.style.opacity = '1';
                }, 130);
                return ()=>clearTimeout(timer);
            }
        }
    }, [
        isMinimized
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            "_v564gl98 _kqswh2mm _1bsb1osq _1q511ejb _85i51ejb",
            isMinimized && "_1q51pxbi _85i5pxbi"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: formatMessage((0, $h9xA7.default).labsLozengeTooltip),
                position: "top",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_kqswstnw _154ipxbi _1xi2pxbi _80om73ad _1pbykb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                            ...tooltipProps,
                            justifyContent: "end",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                                appearance: "new",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                                    ...(0, $h9xA7.default).labsLozenge
                                })
                            })
                        })
                    })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: iconRef,
                "aria-hidden": "true",
                className: (0, $gMc0m.default)([
                    "_v5641020 _kqswstnw _1ltv1ssb _154i1ejb _t9eczr6s _1bsbvbgk _4t3ivbgk",
                    isMinimized && "_1ltvpxbi _154ipxbi _t9ecz12g _1bsbckbl _4t3ickbl"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($hKEhS))),
                    alt: formatMessage((0, $h9xA7.default).remixIconAlt),
                    width: "100%"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_v564aquj _kqswstnw _1ltv1ssb _154iucft _t9eczr6s _o5721q9c",
                    isMinimized && "_1ltv9r46 _154i1f4h _t9ecz12g"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                    size: isMinimized ? 'medium' : 'large',
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...(0, $h9xA7.default).heading
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_v5641v7a _kqswstnw _1ltv1ssb _154i68cl _t9eczr6s _o5721q9c",
                    isMinimized && "_v5641axt _tzy4idpf _lcxvglyw",
                    "_syaz1rpy"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: "small",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aXWIB.FormattedMessage), {
                        ...subtitleMessage
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_v564bxu9 _4t3i1nlq",
                    isMinimized && "_4t3ickbl"
                ])
            })
        ]
    });
} // ── RemixSubTypeGrid ───────────────────────────────────────────────────────
function $adb20307aac79bd1$var$RemixSubTypeGrid({ subTypes: subTypes, onSubTypeSelect: onSubTypeSelect }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $adb20307aac79bd1$var$gridStyles.grid,
        children: subTypes.map((subType)=>{
            const IconComponent = (0, $ks59b.SUB_TYPE_ICON_MAP)[subType.value];
            const label = formatMessage(subType.labelMessage);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: label,
                position: "top",
                children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                        ...tooltipProps,
                        xcss: $adb20307aac79bd1$var$gridStyles.tile,
                        onClick: ()=>onSubTypeSelect(subType.value),
                        testId: subType.testId,
                        "aria-label": label,
                        children: IconComponent ? /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {}) : null
                    })
            }, subType.value);
        })
    });
} // ── RemixAccordionOption ───────────────────────────────────────────────────
const $adb20307aac79bd1$var$animationConfig = {
    duration: ()=>450
};
const $adb20307aac79bd1$var$renderOptionIcon = (option, alt)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7642E.IconTile), {
        icon: option.icon,
        label: alt,
        appearance: option.iconTileAppearance ?? 'gray',
        size: "small",
        shape: "square"
    });
};
function $adb20307aac79bd1$var$RemixAccordionOption({ option: option, isExpanded: isExpanded, onToggle: onToggle, onSubTypeSelect: onSubTypeSelect, onPickForMe: onPickForMe }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const smoothResizer = (0, $4Gau4.useResizingHeight)($adb20307aac79bd1$var$animationConfig);
    const handleToggle = (0, $42omo.useCallback)(()=>{
        onToggle(option.type);
    }, [
        onToggle,
        option.type
    ]);
    const handleSubTypeSelect = (0, $42omo.useCallback)((subTypeValue)=>{
        onSubTypeSelect(option.type, subTypeValue);
    }, [
        onSubTypeSelect,
        option.type
    ]);
    const handlePickForMe = (0, $42omo.useCallback)(()=>{
        onPickForMe(option.type);
    }, [
        onPickForMe,
        option.type
    ]);
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($ghftu)));
    const optionIconAlt = formatMessage(option.iconAltMessage);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            isExpanded ? "_2rko1mok _bfhk1bhr" : "_v5641s6b _2rko1mok _bfhk1bhr _irr319i6 _1dbz130s"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            xcss: $adb20307aac79bd1$var$accordionStyles.accordionWrapper,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
                    xcss: $adb20307aac79bd1$var$accordionStyles.accordionHeader,
                    onClick: handleToggle,
                    testId: option.testId,
                    "aria-expanded": isExpanded,
                    "aria-label": formatMessage(option.labelMessage),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            alignItems: "center",
                            gap: "space.100",
                            children: [
                                $adb20307aac79bd1$var$renderOptionIcon(option, optionIconAlt),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    weight: "medium",
                                    children: formatMessage(option.labelMessage)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)(ChevronIcon, {
                            label: "",
                            color: "var(--ds-icon, #292A2E)"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    ref: smoothResizer.ref,
                    className: (0, $gMc0m.default)([
                        "_1reo15vq _18m915vq"
                    ]),
                    children: isExpanded && /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $adb20307aac79bd1$var$accordionStyles.expandedContent,
                                children: /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$RemixSubTypeGrid, {
                                    subTypes: option.subTypes,
                                    onSubTypeSelect: handleSubTypeSelect
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $adb20307aac79bd1$var$accordionStyles.pickForMeWrapper,
                                children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                    className: (0, $gMc0m.default)([
                                        "_zs1212b0 _1q9ti7a9 _14hp1osq"
                                    ]),
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                        appearance: "subtle",
                                        spacing: "compact",
                                        onClick: handlePickForMe,
                                        testId: `${option.testId}-pick-for-me`,
                                        children: formatMessage((0, $h9xA7.default).pickForMe)
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}
const $adb20307aac79bd1$var$RemixFlatOption = ({ option: option, onSelect: onSelect })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleClick = (0, $42omo.useCallback)(()=>{
        onSelect(option.type);
    }, [
        onSelect,
        option.type
    ]);
    const optionIconAlt = formatMessage(option.iconAltMessage);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_v5641s6b _2rko1mok _bfhk1bhr _irr319i6 _1dbz130s"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
            xcss: $adb20307aac79bd1$var$accordionStyles.accordionWrapper,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                xcss: $adb20307aac79bd1$var$accordionStyles.accordionHeader,
                onClick: handleClick,
                testId: option.testId,
                "aria-label": formatMessage(option.labelMessage),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    alignItems: "center",
                    gap: "space.100",
                    children: [
                        $adb20307aac79bd1$var$renderOptionIcon(option, optionIconAlt),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            weight: "medium",
                            children: formatMessage(option.labelMessage)
                        })
                    ]
                })
            })
        })
    });
};
/**
 * Shared inner content for both RemixOverlay (modal) and RemixPopup (popup).
 * Contains the remix options list, accordion, and describe input.
 */ function $adb20307aac79bd1$var$RemixOverlayContent({ onOptionSelect: onOptionSelect, options: options, subtitle: subtitle }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const [describeValue, setDescribeValue] = (0, $42omo.useState)('');
    const [expandedOption, setExpandedOption] = (0, $42omo.useState)(null);
    const resolvedOptions = (0, $42omo.useMemo)(()=>{
        const base = options ?? (0, $gCqjE.REMIX_OPTIONS);
        const infographicSubTypes = (0, $gCqjE.getInfographicSubTypes)();
        return base.map((opt)=>opt.type === 'infographic' ? {
                ...opt,
                subTypes: infographicSubTypes
            } : opt);
    }, [
        options
    ]);
    const handleDescribeSubmit = (0, $42omo.useCallback)(()=>{
        if (describeValue?.trim()) onOptionSelect?.({
            type: 'custom',
            userPrompt: describeValue
        });
    }, [
        describeValue,
        onOptionSelect
    ]);
    const handleDescribeKeyDown = (0, $42omo.useCallback)((e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleDescribeSubmit();
        }
    }, [
        handleDescribeSubmit
    ]);
    const handleToggle = (0, $42omo.useCallback)((type)=>{
        setExpandedOption((prev)=>prev === type ? null : type);
    }, []);
    const handleSubTypeSelect = (0, $42omo.useCallback)((type, subType)=>{
        onOptionSelect?.({
            type: type,
            subType: subType
        });
    }, [
        onOptionSelect
    ]);
    const handlePickForMe = (0, $42omo.useCallback)((type)=>{
        onOptionSelect?.({
            type: type
        });
    }, [
        onOptionSelect
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$RemixOverlayHeader, {
                subtitle: subtitle,
                isMinimized: expandedOption !== null
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug _18m91wug"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $adb20307aac79bd1$var$remixStyles.modalBodyPadding,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                        space: "space.100",
                        alignInline: "stretch",
                        xcss: $adb20307aac79bd1$var$remixStyles.remixOptionsStack,
                        children: resolvedOptions.map((option)=>option.subTypes.length > 0 ? /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$RemixAccordionOption, {
                                option: option,
                                isExpanded: expandedOption === option.type,
                                onToggle: handleToggle,
                                onSubTypeSelect: handleSubTypeSelect,
                                onPickForMe: handlePickForMe
                            }, option.type) : /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$RemixFlatOption, {
                                option: option,
                                onSelect: handlePickForMe
                            }, option.type))
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $adb20307aac79bd1$var$remixStyles.describeInputBorderWrapper,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $adb20307aac79bd1$var$remixStyles.describeInputWrapper,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fzqvY.default), {
                        onSubmit: handleDescribeSubmit,
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            xcss: $adb20307aac79bd1$var$remixStyles.describePromptRow,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $adb20307aac79bd1$var$remixStyles.describeTextAreaWrapper,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9EtP6.default), {
                                        appearance: "none",
                                        placeholder: formatMessage((0, $h9xA7.default).describePlaceholder),
                                        value: describeValue,
                                        onChange: (e)=>setDescribeValue(e.currentTarget.value),
                                        onKeyDown: handleDescribeKeyDown,
                                        isCompact: true,
                                        minimumRows: 1,
                                        maxHeight: "200px",
                                        resize: "smart",
                                        "aria-label": formatMessage((0, $h9xA7.default).describePlaceholder),
                                        testId: "remix-overlay-describe-input",
                                        name: "remix-overlay-describe"
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                    type: "submit",
                                    appearance: "primary",
                                    isDisabled: !describeValue?.trim(),
                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($euUgw))),
                                    label: formatMessage((0, $h9xA7.default).describeSubmitLabel),
                                    testId: "remix-overlay-describe-submit"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
} /**
   * RemixOverlay — centered ADS Modal presentation
   */ 
function $adb20307aac79bd1$export$48a746fedb7ffb({ onClose: onClose, onOptionSelect: onOptionSelect, options: options, subtitle: subtitle }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
            onClose: onClose,
            width: 320,
            testId: "remix-overlay",
            shouldReturnFocus: false,
            autoFocus: false,
            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _2rko1kw7 _1e0c1txw _2lx21bp4 _bfhkhfxm"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                    hasInlinePadding: false,
                    children: /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$RemixOverlayContent, {
                        onOptionSelect: onOptionSelect,
                        options: options,
                        subtitle: subtitle
                    })
                })
            })
        })
    });
} /**
   * Calls the Popup `update` function to reposition the popup whenever `repositionKey` changes.
   */ 
function $adb20307aac79bd1$var$PopupRepositionOnKeyChange({ repositionKey: repositionKey, update: update }) {
    const prevKey = (0, $42omo.useRef)(repositionKey);
    (0, $42omo.useLayoutEffect)(()=>{
        if (prevKey.current !== repositionKey) {
            prevKey.current = repositionKey;
            update();
        }
    }, [
        repositionKey,
        update
    ]);
    return null;
} /**
   * RemixPopup — anchored ADS Popup presentation for contextual entry points (e.g. object-level sidebar).
   * No blanket, anchored to a trigger element.
   */ 
function $adb20307aac79bd1$export$a8b0b54f368ecbb0({ isOpen: isOpen, onClose: onClose, trigger: trigger, onOptionSelect: onOptionSelect, options: options, subtitle: subtitle, placement: placement = 'left-end', offset: offset = [
    8,
    16
], repositionKey: repositionKey }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: onClose,
        placement: placement,
        offset: offset,
        label: "Remix",
        role: "dialog",
        content: ({ update: update })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$PopupRepositionOnKeyChange, {
                        repositionKey: repositionKey,
                        update: update
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_j7hqjd5d _5sagfnf5 _1pgl1r3m _1o51eoah _1bumglyw"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $adb20307aac79bd1$var$popupStyles.contentWrapper,
                            testId: "remix-popup",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $adb20307aac79bd1$var$popupStyles.body,
                                children: /*#__PURE__*/ (0, $l998X.jsx)($adb20307aac79bd1$var$RemixOverlayContent, {
                                    onOptionSelect: onOptionSelect,
                                    options: options,
                                    subtitle: subtitle
                                })
                            })
                        })
                    })
                ]
            }),
        trigger: (triggerProps)=>trigger(triggerProps)
    });
}
module.exports["RemixOverlay"] = $adb20307aac79bd1$export$48a746fedb7ffb;
module.exports["RemixPopup"] = $adb20307aac79bd1$export$a8b0b54f368ecbb0;

});

parcelRegister("hKEhS", function(module, exports) {
module.exports = new URL("Remix-Illustration.7b8c03b3.svg", import.meta.url).toString();

});

parcelRegister("ks59b", function(module, exports) {
/* constants.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cOrQJ = parcelRequire("cOrQJ");


var $6yRkw = parcelRequire("6yRkw");


var $1UTwf = parcelRequire("1UTwf");


var $5lx52 = parcelRequire("5lx52");


var $ierY5 = parcelRequire("ierY5");


var $5lbk8 = parcelRequire("5lbk8");


var $gF767 = parcelRequire("gF767");


var $izHWc = parcelRequire("izHWc");


var $bPXPh = parcelRequire("bPXPh");


var $8RGsa = parcelRequire("8RGsa");


var $2D3Jd = parcelRequire("2D3Jd");


var $ar6wb = parcelRequire("ar6wb");


var $k2LbV = parcelRequire("k2LbV");


var $hJgiH = parcelRequire("hJgiH");


var $2ia9X = parcelRequire("2ia9X");


var $4oZFp = parcelRequire("4oZFp");


var $7HhWN = parcelRequire("7HhWN");


var $WuWCV = parcelRequire("WuWCV");


var $ao0K5 = parcelRequire("ao0K5");


var $bzbxZ = parcelRequire("bzbxZ");


var $8ecbd = parcelRequire("8ecbd");


var $fF2aS = parcelRequire("fF2aS");


var $9lEwL = parcelRequire("9lEwL");


var $kqIaN = parcelRequire("kqIaN");


var $cCmpe = parcelRequire("cCmpe");


var $40UoD = parcelRequire("40UoD");


var $kQWw1 = parcelRequire("kQWw1");


var $jKLit = parcelRequire("jKLit");


var $8S3cy = parcelRequire("8S3cy");


var $eMdco = parcelRequire("eMdco");


var $54k4v = parcelRequire("54k4v");


var $kgfu3 = parcelRequire("kgfu3");


var $cbrll = parcelRequire("cbrll");

const $ed507872123460ec$var$iconStyles = null;
const $ed507872123460ec$var$SubTypeIcon = ({ src: src, srcDark: srcDark, alt: alt })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const resolvedSrc = colorMode === 'dark' ? srcDark : src;
    return /*#__PURE__*/ (0, $l998X.jsx)("img", {
        src: resolvedSrc,
        alt: alt,
        "aria-hidden": "true",
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1osq _5ral1dfr _1e0c1ule"
        ])
    });
};
const $ed507872123460ec$export$e0452922cbc2989f = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cCmpe))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($bPXPh))),
        alt: "Line chart"
    });
const $ed507872123460ec$export$b08434c95e3df48d = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($WuWCV))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($6yRkw))),
        alt: "Area chart"
    });
const $ed507872123460ec$export$472946dc5493045a = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ao0K5))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($1UTwf))),
        alt: "Bar chart"
    });
const $ed507872123460ec$export$ccba00b0f4d667f3 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fF2aS))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($5lbk8))),
        alt: "Funnel chart"
    });
const $ed507872123460ec$export$b86b18d4ddcc0181 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8S3cy))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($k2LbV))),
        alt: "Pie chart"
    });
const $ed507872123460ec$export$a95ef668d7975f40 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9lEwL))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($gF767))),
        alt: "Gantt chart"
    }); // Diagrams
const $ed507872123460ec$export$4f7cb0192e7b1016 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($40UoD))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($8RGsa))),
        alt: "Mind map"
    });
const $ed507872123460ec$export$2df60ac16db5f072 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8ecbd))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($ierY5))),
        alt: "Flowchart"
    }); // Infographics
const $ed507872123460ec$export$77864082aab0bbe3 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kQWw1))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($2D3Jd))),
        alt: "Modern style"
    });
const $ed507872123460ec$export$b8c6412fcf2fe65d = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($54k4v))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($2ia9X))),
        alt: "Sketch style"
    }); // Visual aids
const $ed507872123460ec$export$c02ff6805d67acb2 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bzbxZ))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($5lx52))),
        alt: "Flip cards"
    });
const $ed507872123460ec$export$368b8c86d4677a50 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eMdco))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($hJgiH))),
        alt: "Quadrant"
    });
const $ed507872123460ec$export$23e94ddbc9d88fae = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cbrll))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7HhWN))),
        alt: "Tree map"
    });
const $ed507872123460ec$export$e5aa73ddcf9d62e8 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kgfu3))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($4oZFp))),
        alt: "Timeline"
    });
const $ed507872123460ec$export$a18ea9af6c181602 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kqIaN))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($izHWc))),
        alt: "Geographical map"
    });
const $ed507872123460ec$export$84442c0324e009f8 = ()=>/*#__PURE__*/ (0, $l998X.jsx)($ed507872123460ec$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jKLit))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($ar6wb))),
        alt: "Org chart"
    }); /**
                                                                                                                             * Maps each sub-type value to its icon component.
                                                                                                                             * Used by the sub-type grid to render the correct icon for each tile.
                                                                                                                             *
                                                                                                                             * Typed as `Record<KnownSubType, …>` so a missing entry is a compile-time error.
                                                                                                                             */ 
const $ed507872123460ec$export$ebd45e32b7708bfa = {
    // Charts
    'line-chart': $ed507872123460ec$export$e0452922cbc2989f,
    'area-chart': $ed507872123460ec$export$b08434c95e3df48d,
    'bar-chart': $ed507872123460ec$export$472946dc5493045a,
    'funnel-chart': $ed507872123460ec$export$ccba00b0f4d667f3,
    'pie-chart': $ed507872123460ec$export$b86b18d4ddcc0181,
    'gantt-chart': $ed507872123460ec$export$a95ef668d7975f40,
    // Diagrams
    mindmap: $ed507872123460ec$export$4f7cb0192e7b1016,
    flowchart: $ed507872123460ec$export$2df60ac16db5f072,
    // Infographics
    'corporate-modern': $ed507872123460ec$export$77864082aab0bbe3,
    'corporate-doodle': $ed507872123460ec$export$b8c6412fcf2fe65d,
    charlie: $ed507872123460ec$export$77864082aab0bbe3,
    // TODO: replace with final minimalist icon once designs are ready
    minimalist: $ed507872123460ec$export$368b8c86d4677a50,
    // Visual aids
    'flip-cards': $ed507872123460ec$export$c02ff6805d67acb2,
    quadrant: $ed507872123460ec$export$368b8c86d4677a50,
    'tree-map': $ed507872123460ec$export$23e94ddbc9d88fae,
    'horizontal-timeline': $ed507872123460ec$export$e5aa73ddcf9d62e8,
    map: $ed507872123460ec$export$a18ea9af6c181602,
    'org-chart': $ed507872123460ec$export$84442c0324e009f8
};
module.exports["SUB_TYPE_ICON_MAP"] = $ed507872123460ec$export$ebd45e32b7708bfa;

});

parcelRegister("6yRkw", function(module, exports) {
module.exports = new URL("area-chart.55f6e465.svg", import.meta.url).toString();

});

parcelRegister("1UTwf", function(module, exports) {
module.exports = new URL("bar-chart.fd78c047.svg", import.meta.url).toString();

});

parcelRegister("5lx52", function(module, exports) {
module.exports = new URL("flip-cards.5ca8ff0a.svg", import.meta.url).toString();

});

parcelRegister("ierY5", function(module, exports) {
module.exports = new URL("flowchart.be00d296.svg", import.meta.url).toString();

});

parcelRegister("5lbk8", function(module, exports) {
module.exports = new URL("funnel-chart.c5c5ee8c.svg", import.meta.url).toString();

});

parcelRegister("gF767", function(module, exports) {
module.exports = new URL("gantt-chart.a8acacb3.svg", import.meta.url).toString();

});

parcelRegister("izHWc", function(module, exports) {
module.exports = new URL("geographical-map.8aed36b5.svg", import.meta.url).toString();

});

parcelRegister("bPXPh", function(module, exports) {
module.exports = new URL("line-chart.170f1aac.svg", import.meta.url).toString();

});

parcelRegister("8RGsa", function(module, exports) {
module.exports = new URL("mindmap.3d2ae695.svg", import.meta.url).toString();

});

parcelRegister("2D3Jd", function(module, exports) {
module.exports = new URL("modern.b9c52e72.svg", import.meta.url).toString();

});

parcelRegister("ar6wb", function(module, exports) {
module.exports = new URL("org-chart.4294f091.svg", import.meta.url).toString();

});

parcelRegister("k2LbV", function(module, exports) {
module.exports = new URL("pie-chart.51f3bebf.svg", import.meta.url).toString();

});

parcelRegister("hJgiH", function(module, exports) {
module.exports = new URL("quadrant.199f7d1e.svg", import.meta.url).toString();

});

parcelRegister("2ia9X", function(module, exports) {
module.exports = new URL("sketch.450eefc9.svg", import.meta.url).toString();

});

parcelRegister("4oZFp", function(module, exports) {
module.exports = new URL("timeline.6ae6674b.svg", import.meta.url).toString();

});

parcelRegister("7HhWN", function(module, exports) {
module.exports = new URL("treemap.1a39a30f.svg", import.meta.url).toString();

});

parcelRegister("WuWCV", function(module, exports) {
module.exports = new URL("area-chart.5c4ca07f.svg", import.meta.url).toString();

});

parcelRegister("ao0K5", function(module, exports) {
module.exports = new URL("bar-chart.958c9357.svg", import.meta.url).toString();

});

parcelRegister("bzbxZ", function(module, exports) {
module.exports = new URL("flip-cards.429027cc.svg", import.meta.url).toString();

});

parcelRegister("8ecbd", function(module, exports) {
module.exports = new URL("flowchart.77339b70.svg", import.meta.url).toString();

});

parcelRegister("fF2aS", function(module, exports) {
module.exports = new URL("funnel-chart.12ecbc63.svg", import.meta.url).toString();

});

parcelRegister("9lEwL", function(module, exports) {
module.exports = new URL("gantt-chart.1c11810d.svg", import.meta.url).toString();

});

parcelRegister("kqIaN", function(module, exports) {
module.exports = new URL("geographical-map.ac5f4483.svg", import.meta.url).toString();

});

parcelRegister("cCmpe", function(module, exports) {
module.exports = new URL("line-chart.57ecd877.svg", import.meta.url).toString();

});

parcelRegister("40UoD", function(module, exports) {
module.exports = new URL("mindmap.d452b507.svg", import.meta.url).toString();

});

parcelRegister("kQWw1", function(module, exports) {
module.exports = new URL("modern.4ca836a7.svg", import.meta.url).toString();

});

parcelRegister("jKLit", function(module, exports) {
module.exports = new URL("org-chart.694f44ab.svg", import.meta.url).toString();

});

parcelRegister("8S3cy", function(module, exports) {
module.exports = new URL("pie-chart.0477082d.svg", import.meta.url).toString();

});

parcelRegister("eMdco", function(module, exports) {
module.exports = new URL("quadrant.5175de07.svg", import.meta.url).toString();

});

parcelRegister("54k4v", function(module, exports) {
module.exports = new URL("sketch.35e2121b.svg", import.meta.url).toString();

});

parcelRegister("kgfu3", function(module, exports) {
module.exports = new URL("timeline.3d28aa4e.svg", import.meta.url).toString();

});

parcelRegister("cbrll", function(module, exports) {
module.exports = new URL("treemap.1a39a30f.svg", import.meta.url).toString();

});

parcelRegister("h9xA7", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $59c006c6ea12a553$var$messages = (0, $aXWIB.defineMessages)({
    // ── Header ──────────────────────────────────────────────────────────────
    heading: {
        id: "malleable-ui-components.remix.heading",
        defaultMessage: "Remix"
    },
    subtitle: {
        id: "malleable-ui-components.remix.subtitle",
        defaultMessage: "View this content in a new form"
    },
    labsLozenge: {
        id: "malleable-ui-components.remix.labs-lozenge",
        defaultMessage: "LABS"
    },
    labsLozengeTooltip: {
        id: "malleable-ui-components.remix.option.lozenge-tooltip",
        defaultMessage: "Beta: This feature is still in development."
    },
    remixIconAlt: {
        id: "malleable-ui-components.remix.icon-alt",
        defaultMessage: "Remix icon"
    },
    // ── Describe input ─────────────────────────────────────────────────────
    describePlaceholder: {
        id: "malleable-ui-components.remix.describe-placeholder",
        defaultMessage: "Or describe your remix..."
    },
    describeSubmitLabel: {
        id: "malleable-ui-components.remix.describe-submit-label",
        defaultMessage: "Submit"
    },
    // ── Top-level option labels ────────────────────────────────────────────
    remixOptionChart: {
        id: "malleable-ui-components.remix.option.chart",
        defaultMessage: "Chart"
    },
    remixOptionDiagram: {
        id: "malleable-ui-components.remix.option.diagram",
        defaultMessage: "Diagram"
    },
    remixOptionInfographic: {
        id: "malleable-ui-components.remix.option.infographic",
        defaultMessage: "Infographic"
    },
    remixOptionVisualization: {
        id: "malleable-ui-components.remix.option.visualization",
        defaultMessage: "Visualization"
    },
    // ── Top-level option icon alts ─────────────────────────────────────────
    chartIconAlt: {
        id: "malleable-ui-components.remix.option.chart-icon-alt",
        defaultMessage: "Chart icon"
    },
    diagramIconAlt: {
        id: "malleable-ui-components.remix.option.diagram-icon-alt",
        defaultMessage: "Diagram icon"
    },
    infographicIconAlt: {
        id: "malleable-ui-components.remix.option.infographic-icon-alt",
        defaultMessage: "Infographic icon"
    },
    visualizationIconAlt: {
        id: "malleable-ui-components.remix.option.visualization-icon-alt",
        defaultMessage: "Visualization icon"
    },
    // ── Top-level option tooltips ──────────────────────────────────────────
    chartTooltip: {
        id: "malleable-ui-components.remix.option.chart-tooltip",
        defaultMessage: "View your data as a chart or graph"
    },
    diagramTooltip: {
        id: "malleable-ui-components.remix.option.diagram-tooltip",
        defaultMessage: "Show relationships with a diagram"
    },
    infographicTooltip: {
        id: "malleable-ui-components.remix.option.infographic-tooltip",
        defaultMessage: "Summarize key points with an infographic"
    },
    visualizationTooltip: {
        id: "malleable-ui-components.remix.option.visualization-tooltip",
        defaultMessage: "Bring your content to life with a bespoke visual"
    },
    // ── Sub-type labels (charts) ───────────────────────────────────────────
    subTypeLineChart: {
        id: "malleable-ui-components.remix.sub-type.line-chart",
        defaultMessage: "Line chart"
    },
    subTypeAreaChart: {
        id: "malleable-ui-components.remix.sub-type.area-chart",
        defaultMessage: "Area chart"
    },
    subTypeBarChart: {
        id: "malleable-ui-components.remix.sub-type.bar-chart",
        defaultMessage: "Bar chart"
    },
    subTypeFunnelChart: {
        id: "malleable-ui-components.remix.sub-type.funnel-chart",
        defaultMessage: "Funnel chart"
    },
    subTypePieChart: {
        id: "malleable-ui-components.remix.sub-type.pie-chart",
        defaultMessage: "Pie chart"
    },
    subTypeGanttChart: {
        id: "malleable-ui-components.remix.sub-type.gantt-chart",
        defaultMessage: "Gantt chart"
    },
    // ── Sub-type labels (diagrams) ─────────────────────────────────────────
    subTypeMindMap: {
        id: "malleable-ui-components.remix.sub-type.mind-map",
        defaultMessage: "Mindmap"
    },
    subTypeFlowChart: {
        id: "malleable-ui-components.remix.sub-type.flow-chart",
        defaultMessage: "Flowchart"
    },
    // ── Sub-type labels (infographics) ─────────────────────────────────────
    subTypeModernStyle: {
        id: "malleable-ui-components.remix.sub-type.modern-style",
        defaultMessage: "Modern style"
    },
    subTypeSketchStyle: {
        id: "malleable-ui-components.remix.sub-type.sketch-style",
        defaultMessage: "Sketch style"
    },
    subTypeMinimalistStyle: {
        id: "malleable-ui-components.remix.sub-type.minimalist-style",
        defaultMessage: "Minimalist style"
    },
    // ── Sub-type labels (visual aids) ──────────────────────────────────────
    subTypeFlipCard: {
        id: "malleable-ui-components.remix.sub-type.flip-card",
        defaultMessage: "Flip card"
    },
    subTypeQuadrant: {
        id: "malleable-ui-components.remix.sub-type.quadrant",
        defaultMessage: "Quadrant"
    },
    subTypeTreeMap: {
        id: "malleable-ui-components.remix.sub-type.tree-map",
        defaultMessage: "Tree map"
    },
    subTypeTimeline: {
        id: "malleable-ui-components.remix.sub-type.timeline",
        defaultMessage: "Timeline"
    },
    subTypeGeographicalMap: {
        id: "malleable-ui-components.remix.sub-type.geographical-map",
        defaultMessage: "Geographical map"
    },
    subTypeOrgChart: {
        id: "malleable-ui-components.remix.sub-type.org-chart",
        defaultMessage: "Org chart"
    },
    pageRemixSubtitle: {
        id: "malleable-ui-components.remix.page-remix-subtitle",
        defaultMessage: "Create content inspired by this work"
    },
    remixOptionSlides: {
        id: "malleable-ui-components.remix.option.slides",
        defaultMessage: "Slides"
    },
    remixOptionWhiteboard: {
        id: "malleable-ui-components.remix.option.whiteboard",
        defaultMessage: "Whiteboard"
    },
    remixOptionDatabase: {
        id: "malleable-ui-components.remix.option.database",
        defaultMessage: "Database"
    },
    slidesIconAlt: {
        id: "malleable-ui-components.remix.option.slides-icon-alt",
        defaultMessage: "Slides icon"
    },
    whiteboardIconAlt: {
        id: "malleable-ui-components.remix.option.whiteboard-icon-alt",
        defaultMessage: "Whiteboard icon"
    },
    databaseIconAlt: {
        id: "malleable-ui-components.remix.option.database-icon-alt",
        defaultMessage: "Database icon"
    },
    slidesTooltip: {
        id: "malleable-ui-components.remix.option.slides-tooltip",
        defaultMessage: "Transform your page into a slide deck"
    },
    whiteboardTooltip: {
        id: "malleable-ui-components.remix.option.whiteboard-tooltip",
        defaultMessage: "Visualize your page on a whiteboard"
    },
    databaseTooltip: {
        id: "malleable-ui-components.remix.option.database-tooltip",
        defaultMessage: "Structure your page content as a database"
    },
    // ── Pick for me ────────────────────────────────────────────────────────
    pickForMe: {
        id: "malleable-ui-components.remix.pick-for-me",
        defaultMessage: "Pick for me"
    },
    // ── Unused legacy keys kept for i18n backwards compat ──────────────────
    selectedContent: {
        id: "malleable-ui-components.remix.selected-content",
        defaultMessage: "Selected content"
    },
    noContent: {
        id: "malleable-ui-components.remix.no-content",
        defaultMessage: "No content selected"
    }
});
var $59c006c6ea12a553$export$2e2bcd8739ae039 = $59c006c6ea12a553$var$messages;
module.exports["default"] = $59c006c6ea12a553$export$2e2bcd8739ae039;

});

parcelRegister("gCqjE", function(module, exports) {

var $1zLiv = parcelRequire("1zLiv");


var $33kXB = parcelRequire("33kXB");


var $ejLrs = parcelRequire("ejLrs");


var $6B0jU = parcelRequire("6B0jU");


var $8cjip = parcelRequire("8cjip");


var $5XpHP = parcelRequire("5XpHP");


var $ZDq1z = parcelRequire("ZDq1z");


var $dh538 = parcelRequire("dh538");


var $h9xA7 = parcelRequire("h9xA7");

/**
 * All available remix options with their sub-types (variants).
 *
 * Sub-type values match the backend `dynamicUiSubtype` parameter
 * used in the remix-content minion (see edit-with-rovo-bar).
 */ const $9c8cc259dbbf2fad$var$defaultInfographicSubTypes = [
    {
        value: 'corporate-modern',
        displayName: 'modern style infographic',
        labelMessage: (0, $h9xA7.default).subTypeModernStyle,
        testId: 'remix-sub-type-corporate-modern'
    },
    {
        value: 'corporate-doodle',
        displayName: 'sketch style infographic',
        labelMessage: (0, $h9xA7.default).subTypeSketchStyle,
        testId: 'remix-sub-type-corporate-doodle'
    }
];
const $9c8cc259dbbf2fad$var$newInfographicSubTypes = [
    {
        value: 'charlie',
        displayName: 'modern style infographic',
        labelMessage: (0, $h9xA7.default).subTypeModernStyle,
        testId: 'remix-sub-type-charlie'
    },
    {
        value: 'minimalist',
        displayName: 'minimalist style infographic',
        labelMessage: (0, $h9xA7.default).subTypeMinimalistStyle,
        testId: 'remix-sub-type-minimalist'
    },
    {
        value: 'corporate-doodle',
        displayName: 'sketch style infographic',
        labelMessage: (0, $h9xA7.default).subTypeSketchStyle,
        testId: 'remix-sub-type-corporate-doodle'
    }
];
function $9c8cc259dbbf2fad$export$b867d47ced1865f7() {
    return (0, $dh538.fg)('confluence_infographics_enable_new_styles') ? $9c8cc259dbbf2fad$var$newInfographicSubTypes : $9c8cc259dbbf2fad$var$defaultInfographicSubTypes;
}
const $9c8cc259dbbf2fad$export$f0ba07b8deaf6c2d = [
    {
        type: 'chart',
        displayName: 'chart',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1zLiv))),
        labelMessage: (0, $h9xA7.default).remixOptionChart,
        iconAltMessage: (0, $h9xA7.default).chartIconAlt,
        tooltipMessage: (0, $h9xA7.default).chartTooltip,
        testId: 'remix-overlay-option-chart',
        subTypes: [
            {
                value: 'line-chart',
                displayName: 'line chart',
                labelMessage: (0, $h9xA7.default).subTypeLineChart,
                testId: 'remix-sub-type-line-chart'
            },
            {
                value: 'area-chart',
                displayName: 'area chart',
                labelMessage: (0, $h9xA7.default).subTypeAreaChart,
                testId: 'remix-sub-type-area-chart'
            },
            {
                value: 'bar-chart',
                displayName: 'bar chart',
                labelMessage: (0, $h9xA7.default).subTypeBarChart,
                testId: 'remix-sub-type-bar-chart'
            },
            {
                value: 'funnel-chart',
                displayName: 'funnel chart',
                labelMessage: (0, $h9xA7.default).subTypeFunnelChart,
                testId: 'remix-sub-type-funnel-chart'
            },
            {
                value: 'pie-chart',
                displayName: 'pie chart',
                labelMessage: (0, $h9xA7.default).subTypePieChart,
                testId: 'remix-sub-type-pie-chart'
            },
            {
                value: 'gantt-chart',
                displayName: 'Gantt chart',
                labelMessage: (0, $h9xA7.default).subTypeGanttChart,
                testId: 'remix-sub-type-gantt-chart'
            }
        ]
    },
    {
        type: 'diagram',
        displayName: 'diagram',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($33kXB))),
        labelMessage: (0, $h9xA7.default).remixOptionDiagram,
        iconAltMessage: (0, $h9xA7.default).diagramIconAlt,
        tooltipMessage: (0, $h9xA7.default).diagramTooltip,
        testId: 'remix-overlay-option-diagram',
        subTypes: [
            {
                value: 'mindmap',
                displayName: 'mind map',
                labelMessage: (0, $h9xA7.default).subTypeMindMap,
                testId: 'remix-sub-type-mindmap'
            },
            {
                value: 'flowchart',
                displayName: 'flowchart',
                labelMessage: (0, $h9xA7.default).subTypeFlowChart,
                testId: 'remix-sub-type-flowchart'
            }
        ]
    },
    {
        type: 'infographic',
        displayName: 'infographic',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ejLrs))),
        labelMessage: (0, $h9xA7.default).remixOptionInfographic,
        iconAltMessage: (0, $h9xA7.default).infographicIconAlt,
        tooltipMessage: (0, $h9xA7.default).infographicTooltip,
        testId: 'remix-overlay-option-infographic',
        subTypes: $9c8cc259dbbf2fad$var$defaultInfographicSubTypes
    },
    {
        type: 'visual-aid',
        displayName: 'visualization',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8cjip))),
        labelMessage: (0, $h9xA7.default).remixOptionVisualization,
        iconAltMessage: (0, $h9xA7.default).visualizationIconAlt,
        tooltipMessage: (0, $h9xA7.default).visualizationTooltip,
        testId: 'remix-overlay-option-visual-aid',
        subTypes: [
            {
                value: 'flip-cards',
                displayName: 'flip card',
                labelMessage: (0, $h9xA7.default).subTypeFlipCard,
                testId: 'remix-sub-type-flip-cards'
            },
            {
                value: 'quadrant',
                displayName: 'quadrant',
                labelMessage: (0, $h9xA7.default).subTypeQuadrant,
                testId: 'remix-sub-type-quadrant'
            },
            {
                value: 'tree-map',
                displayName: 'tree map',
                labelMessage: (0, $h9xA7.default).subTypeTreeMap,
                testId: 'remix-sub-type-tree-map'
            },
            {
                value: 'horizontal-timeline',
                displayName: 'timeline',
                labelMessage: (0, $h9xA7.default).subTypeTimeline,
                testId: 'remix-sub-type-horizontal-timeline'
            },
            {
                value: 'map',
                displayName: 'map',
                labelMessage: (0, $h9xA7.default).subTypeGeographicalMap,
                testId: 'remix-sub-type-map'
            },
            {
                value: 'org-chart',
                displayName: 'org chart',
                labelMessage: (0, $h9xA7.default).subTypeOrgChart,
                testId: 'remix-sub-type-org-chart'
            }
        ]
    }
];
const $9c8cc259dbbf2fad$export$839e8948e17d6e68 = [
    {
        type: 'slides',
        displayName: 'slides',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5XpHP))),
        labelMessage: (0, $h9xA7.default).remixOptionSlides,
        iconAltMessage: (0, $h9xA7.default).slidesIconAlt,
        tooltipMessage: (0, $h9xA7.default).slidesTooltip,
        testId: 'remix-overlay-option-slides',
        subTypes: [],
        iconTileAppearance: 'green'
    },
    {
        type: 'whiteboard',
        displayName: 'whiteboard',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        labelMessage: (0, $h9xA7.default).remixOptionWhiteboard,
        iconAltMessage: (0, $h9xA7.default).whiteboardIconAlt,
        tooltipMessage: (0, $h9xA7.default).whiteboardTooltip,
        testId: 'remix-overlay-option-whiteboard',
        subTypes: [],
        iconTileAppearance: 'teal'
    },
    {
        type: 'database',
        displayName: 'database',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        labelMessage: (0, $h9xA7.default).remixOptionDatabase,
        iconAltMessage: (0, $h9xA7.default).databaseIconAlt,
        tooltipMessage: (0, $h9xA7.default).databaseTooltip,
        testId: 'remix-overlay-option-database',
        subTypes: [],
        iconTileAppearance: 'purple'
    },
    {
        type: 'infographic',
        displayName: 'infographic',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ejLrs))),
        labelMessage: (0, $h9xA7.default).remixOptionInfographic,
        iconAltMessage: (0, $h9xA7.default).infographicIconAlt,
        tooltipMessage: (0, $h9xA7.default).infographicTooltip,
        testId: 'remix-overlay-option-infographic',
        subTypes: $9c8cc259dbbf2fad$var$defaultInfographicSubTypes
    }
];
/**
 * Builds a combined list of all remix options with FG-gated infographic subtypes.
 * Called at render time to ensure feature flags are resolved.
 */ function $9c8cc259dbbf2fad$var$getAllOptions() {
    const infographicSubTypes = $9c8cc259dbbf2fad$export$b867d47ced1865f7();
    return [
        ...$9c8cc259dbbf2fad$export$f0ba07b8deaf6c2d,
        ...$9c8cc259dbbf2fad$export$839e8948e17d6e68
    ].map((opt)=>opt.type === 'infographic' ? {
            ...opt,
            subTypes: infographicSubTypes
        } : opt);
}
function $9c8cc259dbbf2fad$export$b3104233810c1e93(typeValue) {
    const match = $9c8cc259dbbf2fad$var$getAllOptions().find((option)=>option.type === typeValue);
    return match?.displayName ?? typeValue.replace(/-/g, ' ');
}
function $9c8cc259dbbf2fad$export$ca76798d0446453(subTypeValue) {
    for (const option of $9c8cc259dbbf2fad$var$getAllOptions()){
        const match = option.subTypes.find((st)=>st.value === subTypeValue);
        if (match) return match.displayName;
    }
    return subTypeValue.replace(/-/g, ' ');
}
module.exports["getInfographicSubTypes"] = $9c8cc259dbbf2fad$export$b867d47ced1865f7;
module.exports["REMIX_OPTIONS"] = $9c8cc259dbbf2fad$export$f0ba07b8deaf6c2d;
module.exports["PAGE_REMIX_OPTIONS"] = $9c8cc259dbbf2fad$export$839e8948e17d6e68;
module.exports["getTypeDisplayName"] = $9c8cc259dbbf2fad$export$b3104233810c1e93;
module.exports["getSubTypeDisplayName"] = $9c8cc259dbbf2fad$export$ca76798d0446453;

});

parcelRegister("7JKd3", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $1qfLF = parcelRequire("1qfLF");


var $5lVpa = parcelRequire("5lVpa");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $6UNNU = parcelRequire("6UNNU");


var $ckeTN = parcelRequire("ckeTN");

const $80dee16929296708$var$messages = (0, $aXWIB.defineMessages)({
    escHint: {
        id: "malleable-ui-components.remix-thinking-bar.esc-hint",
        defaultMessage: "Esc"
    },
    stopLabel: {
        id: "malleable-ui-components.remix-thinking-bar.stop-label",
        defaultMessage: "Stop remixing"
    },
    rovoIsThinking: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.rovo-is-thinking",
        defaultMessage: "Rovo is thinking"
    },
    analyzingContent: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.analyzing-content",
        defaultMessage: "Analyzing your content"
    },
    puttingPiecesTogether: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.putting-pieces-together",
        defaultMessage: "Putting the pieces together"
    },
    structuringRemix: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.structuring-remix",
        defaultMessage: "Structuring your remix"
    },
    designingRemix: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.designing-remix",
        defaultMessage: "Designing your remix"
    },
    addingItAllTogether: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.adding-it-all-together",
        defaultMessage: "Adding it all together"
    },
    applyingFinalTouches: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.applying-final-touches",
        defaultMessage: "Applying the final touches"
    },
    almostDone: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.almost-done",
        defaultMessage: "Almost done"
    }
});
/**
 * Interval in ms between each rotating thinking message step.
 */ const $80dee16929296708$var$ROTATION_INTERVAL_MS = 4000; /**
                                    * Hook that cycles through an ordered list of strings at a fixed interval,
                                    * advancing sequentially (not shuffled). Stays on the last item once exhausted.
                                    *
                                    * The `texts` array is treated as stable on mount — only the initial value is
                                    * used to set up the interval, so callers should ensure the array does not
                                    * change identity unnecessarily (e.g. by defining it outside the render or
                                    * memoising it).
                                    */ 
function $80dee16929296708$var$useSequentialText(texts) {
    const [index, setIndex] = (0, $42omo.useState)(0);
    const indexRef = (0, $42omo.useRef)(0); // Keep latest texts accessible inside the interval callback without
    // re-creating the interval on every render.
    const textsRef = (0, $42omo.useRef)(texts);
    textsRef.current = texts;
    (0, $42omo.useEffect)(()=>{
        if (textsRef.current.length <= 1) return;
        const interval = setInterval(()=>{
            const next = indexRef.current + 1;
            if (next < textsRef.current.length) {
                indexRef.current = next;
                setIndex(next);
            } else // Sequence exhausted — stay on the last message
            clearInterval(interval);
        }, $80dee16929296708$var$ROTATION_INTERVAL_MS);
        return ()=>clearInterval(interval); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Mount-only: the sequence is fixed for the lifetime of the component
    return textsRef.current[index] ?? textsRef.current[0] ?? '';
}
const $80dee16929296708$var$styles = {
    gradientWrapper: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _y44vh5ps _2rko1tm3 _kqsw1n9t _94n5pxbi _1ltv1b66 _1xi21b66 _1bsb1ns9 _1pbyni7l",
    gradientInner: "_2rko1kw7 _1rjcv77o _18zrv77o _bfhk1bhr _1y1m1ntv _16qs130s",
    fixedWrapper: "_2rko1tm3 _zulpu2gc _18zrpxbi _1rjcu2gc _1e0c1txw _4cvr1h6o _1bah1yb4 _1ul91kdj",
    escBadge: "_2rko12b0 _11c8wadc _18zr1b66 _1rjcv77o _bfhkysee _syaz1rpy"
};
function $80dee16929296708$export$d6f2d83daf5efc44({ onStop: onStop, optionType: _optionType }) {
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const thinkingTexts = [
        formatMessage($80dee16929296708$var$messages.rovoIsThinking),
        formatMessage($80dee16929296708$var$messages.analyzingContent),
        formatMessage($80dee16929296708$var$messages.puttingPiecesTogether),
        formatMessage($80dee16929296708$var$messages.structuringRemix),
        formatMessage($80dee16929296708$var$messages.designingRemix),
        formatMessage($80dee16929296708$var$messages.addingItAllTogether),
        formatMessage($80dee16929296708$var$messages.applyingFinalTouches),
        formatMessage($80dee16929296708$var$messages.almostDone)
    ];
    const thinkingTitle = $80dee16929296708$var$useSequentialText(thinkingTexts);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- gradient background not expressible in cssMap
    , {
        style: {
            background: (0, $ckeTN.ROVO_GRADIENT_BACKGROUND)
        },
        "data-testid": "remix-thinking-bar-gradient-border",
        className: (0, $gMc0m.default)([
            $80dee16929296708$var$styles.gradientWrapper
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ckeTN.RovoGradientKeyframesStyle), {}),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $80dee16929296708$var$styles.gradientInner
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    as: "div",
                    xcss: $80dee16929296708$var$styles.fixedWrapper,
                    testId: "remix-thinking-bar",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6UNNU.RovoThinkingIndicator), {
                            title: thinkingTitle
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            alignBlock: "center",
                            space: "space.100",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    as: "span",
                                    xcss: $80dee16929296708$var$styles.escBadge,
                                    children: formatMessage($80dee16929296708$var$messages.escHint)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                    shape: "circle",
                                    onClick: onStop,
                                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5lVpa))), {
                                            ...iconProps,
                                            color: "var(--ds-icon-danger, #C9372C)",
                                            label: ""
                                        }),
                                    label: formatMessage($80dee16929296708$var$messages.stopLabel)
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
module.exports["RemixThinkingBar"] = $80dee16929296708$export$d6f2d83daf5efc44;

});

parcelRegister("9WfmN", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $c6GJD = parcelRequire("c6GJD");


var $cc6UM = parcelRequire("cc6UM");


var $1uunn = parcelRequire("1uunn");

const $326813fdf830e5de$export$205c270e325a7524 = (aaid)=>{
    const preferences = JSON.parse(localStorage.getItem((0, $cc6UM.LS_USER_PREFERENCES_KEY)) || '{}');
    return preferences[aaid];
};
const $326813fdf830e5de$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        preferences: {
            // ideally we want to set the preference in the react component because
            // FF evaluated in module level may not resolve to correct value during SSR
            // however because there is localStorage setting and `firstLoad`, it requires a bit of refactoring to do it
            // this feature is only needed for dogfooding, so may not worth the refactor
            storeUserMessages: (0, $c6GJD.default).initializeCalled() && (0, $c6GJD.default).checkGate('ai_mate_show_store_messages'),
            useEditorContext: true
        },
        firstLoad: true
    },
    actions: {
        updatePreferences: (data)=>({ setState: setState, getState: getState })=>{
                setState({
                    preferences: {
                        ...getState().preferences,
                        ...data
                    },
                    firstLoad: false
                });
            }
    }
});
const $326813fdf830e5de$var$useStore = (0, $9zUhf.createHook)($326813fdf830e5de$var$store);
const $326813fdf830e5de$export$b6472e0d8983f5f5 = ()=>{
    const { aaid: aaid } = (0, $1uunn.useProfileController)();
    const [{ preferences: preferences, firstLoad: firstLoad }, { updatePreferences: storeUpdatePreferences }] = $326813fdf830e5de$var$useStore();
    const updatePreferences = (0, $42omo.useCallback)((data)=>{
        if (!aaid) return;
        storeUpdatePreferences(data);
        localStorage.setItem((0, $cc6UM.LS_USER_PREFERENCES_KEY), JSON.stringify({
            [aaid]: {
                ...preferences,
                ...data
            }
        }));
    }, [
        aaid,
        preferences,
        storeUpdatePreferences
    ]);
    const setStoreUserMessages = (0, $42omo.useCallback)((storeUserMessages)=>{
        updatePreferences({
            storeUserMessages: storeUserMessages
        });
    }, [
        updatePreferences
    ]);
    const setUseEditorContext = (0, $42omo.useCallback)((useEditorContext)=>{
        updatePreferences({
            useEditorContext: useEditorContext
        });
    }, [
        updatePreferences
    ]);
    const setHasSeenFeedbackOptInPrompt = (0, $42omo.useCallback)((hasSeenFeedbackOptInPrompt)=>{
        updatePreferences({
            hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt
        });
    }, [
        updatePreferences
    ]);
    (0, $42omo.useEffect)(()=>{
        if (aaid && firstLoad) {
            const preferences = $326813fdf830e5de$export$205c270e325a7524(aaid);
            if (preferences) updatePreferences(preferences);
        }
    }, [
        aaid,
        firstLoad,
        updatePreferences
    ]);
    return {
        preferences: preferences,
        setStoreUserMessages: setStoreUserMessages,
        setUseEditorContext: setUseEditorContext,
        setHasSeenFeedbackOptInPrompt: setHasSeenFeedbackOptInPrompt
    };
};
module.exports["useUserPreferences"] = $326813fdf830e5de$export$b6472e0d8983f5f5;

});

parcelRegister("cc6UM", function(module, exports) {
const $4c20625651a86f0f$export$97d0beb2ccc70a4d = 'aiMateUserPreferences';
module.exports["LS_USER_PREFERENCES_KEY"] = $4c20625651a86f0f$export$97d0beb2ccc70a4d;

});

parcelRegister("3rRes", function(module, exports) {

var $6jPem = parcelRequire("6jPem");


var $er2Wy = parcelRequire("er2Wy");

const $b43257b5198523a8$export$cee0b7c2921c06e1 = (nodes)=>{
    if (nodes === null) return null;
    const result = [];
    for (const node of nodes){
        const filtered = (0, $6jPem.traverse)(node, {
            any: (adfNode)=>{
                if ((0, $er2Wy.isRemixRestrictedNodeType)(adfNode.type)) return false;
            }
        });
        if (filtered !== false) result.push(filtered);
    }
    return result;
};
module.exports["filterRemixFragmentNodes"] = $b43257b5198523a8$export$cee0b7c2921c06e1;

});

parcelRegister("er2Wy", function(module, exports) {
/**
 * Remix button visibility for Malleable Content. Canonical deny list and show rules.
 * Use with block-controls activeNode (or a full PM node) and these filters in both edit and view.
 */ 
var $l9G9n = parcelRequire("l9G9n");

const $9531e9c3be1ec0bb$export$d3f1ba79de0d4efe = [
    'mediaSingle',
    'media'
];
const $9531e9c3be1ec0bb$export$7004846771b000c0 = [
    'mediaSingle',
    'mediaGroup',
    'media',
    'image',
    'extension',
    'bodiedExtension',
    'multiBodiedExtension',
    'embedCard',
    'blockCard',
    'inlineCard',
    'bodiedSyncBlock'
];
const $9531e9c3be1ec0bb$var$DENY_SET = new Set($9531e9c3be1ec0bb$export$7004846771b000c0);
const $9531e9c3be1ec0bb$export$bf9aef57175a93a2 = (nodeType)=>$9531e9c3be1ec0bb$var$DENY_SET.has(nodeType);
const $9531e9c3be1ec0bb$export$ff7e5ebac3487125 = (context)=>{
    const nodeType = context.node?.type?.name ?? context.nodeType;
    if (nodeType === undefined) return false;
    if ($9531e9c3be1ec0bb$export$bf9aef57175a93a2(nodeType)) return false;
    // With full node, also require non-empty (e.g. don't show Remix on empty paragraphs).
    // Exception: layoutSection is always remixable regardless of content — it can be empty
    // and the user should still be able to remix it to generate content.
    if (context.node !== undefined && nodeType !== 'layoutSection') return !(0, $l9G9n.isNodeEmpty)(context.node);
    return true;
};
module.exports["ASK_ROVO_MEDIA_NODE_TYPES"] = $9531e9c3be1ec0bb$export$d3f1ba79de0d4efe;
module.exports["REMIX_DENY_LIST_V1"] = $9531e9c3be1ec0bb$export$7004846771b000c0;
module.exports["isRemixRestrictedNodeType"] = $9531e9c3be1ec0bb$export$bf9aef57175a93a2;
module.exports["shouldShowRemixForSelectionContext"] = $9531e9c3be1ec0bb$export$ff7e5ebac3487125;

});

parcelRegister("7eOZ4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kyKWe = parcelRequire("kyKWe");


var $2O3ot = parcelRequire("2O3ot");


var $bPHr8 = parcelRequire("bPHr8");


var $jEzab = parcelRequire("jEzab");


var $9WfmN = parcelRequire("9WfmN");


var $aouqA = parcelRequire("aouqA");


var $cteoa = parcelRequire("cteoa");


var $gCqjE = parcelRequire("gCqjE");


var $3vCSA = parcelRequire("3vCSA");


var $3jwuS = parcelRequire("3jwuS");


var $jyA9t = parcelRequire("jyA9t");


var $ep3mz = parcelRequire("ep3mz");


var $ew8wg = parcelRequire("ew8wg");


var $htsj6 = parcelRequire("htsj6");


var $6mKj3 = parcelRequire("6mKj3");

const $1e31de274ed01603$var$isActionComplete = (chatMessages)=>{
    // Scan backwards to find ACTION_COMPLETE in the latest turn.
    // If we encounter a HUMAN message first, that marks a turn boundary —
    // any ACTION_COMPLETE before it belongs to a previous turn.
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_COMPLETE') return true;
        if ((0, $bPHr8.isStoreHuman)(message)) return false;
    }
    return false;
};
function $1e31de274ed01603$var$shouldOpenEphemeralPreview(chatMessages) {
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_PREPARE') return message.action ? (0, $3vCSA.isRemixGeneratedFlow)(message.action) : false;
    }
    return false;
}
const $1e31de274ed01603$var$isWhiteboardRemixActionKey = (key)=>key === (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) || key === (0, $3vCSA.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY);
/**
 * True when the latest matching assistant action is a whiteboard create/update
 * and checks if the action is in the ACTION_PART streaming status.
 * (`MessageAction.status === 'streaming'`).
 */ const $1e31de274ed01603$var$hasWhiteboardRemixActionStreaming = (chatMessages)=>(0, $cteoa.findLastAssistantAction)(chatMessages, (action)=>$1e31de274ed01603$var$isWhiteboardRemixActionKey(action.key) && action.status?.toLowerCase() === 'streaming') !== undefined;
const $1e31de274ed01603$export$cca9e2432f59b3f8 = ({ onActionReady: onActionReady, stagingAreaTargetMode: stagingAreaTargetMode = 'current-content' } = {})=>{
    const { sendMessage: sendMessage, createConversationOptimistically: createConversationOptimistically, abortRequests: abortRequests, activeConversation: activeConversation, setSelectedConversation: setSelectedConversation } = (0, $aouqA.useSmartCreationChatStoreApi)();
    const { setPrompt: setPrompt, setDynamicUiContext: setDynamicUiContext, setForceSkipAutoConversationSelection: setForceSkipAutoConversationSelection } = (0, $2O3ot.useStagingAreaActions)();
    const { preferences: preferences } = (0, $9WfmN.useUserPreferences)();
    const { openModal: openModal, closeModal: closeModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { title: contentTitle } = (0, $ew8wg.usePageTitle)({
        contentId: contentId ?? ''
    });
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isDraftPage = contentStatus === 'draft';
    // Track the conversation ID created by this remix flow. Only when the
    // store's activeConversation matches this ID do we consider it "ours".
    // Stored as state so that setting it triggers a rerender, ensuring
    // derived values (activeRemixConversation, chatMessages, etc.) update
    // immediately rather than waiting for an external rerender.
    const [remixConversationId, setRemixConversationId] = (0, $42omo.useState)(undefined);
    const activeRemixConversation = activeConversation?.id && activeConversation.id === remixConversationId ? activeConversation : null;
    const [chatMessages] = (0, $jEzab.useChatMessages)({
        conversationId: activeRemixConversation?.id ?? ''
    });
    // Extract the first StoreError from chatMessages so callers can surface
    // the specific Rovo error message as an experience attribute.
    const remixStoreError = chatMessages.find((message)=>(0, $bPHr8.isStoreError)(message)) ?? null;
    // Detect whether Rovo encountered an error while processing a remix request.
    // This covers ACTION_ERROR at any stage — both before the ephemeral preview
    // opens (during awaitingResponse) and while it is loading (during typingResponse).
    // Uses the same isStoreError check as the smart-creation staging area.
    const isRemixError = activeRemixConversation?.status === (0, $bPHr8.CHAT_STORE_STATUS).deactivatedAgentError || remixStoreError !== null;
    // Track whether the onActionReady callback has already been fired for the
    // current conversation to avoid duplicate invocations.
    const actionReadyFired = (0, $42omo.useRef)(false);
    // Reset the fired flag when the active remix conversation changes (new remix flow).
    const prevConversationId = (0, $42omo.useRef)(activeRemixConversation?.id);
    (0, $42omo.useEffect)(()=>{
        if (prevConversationId.current !== activeRemixConversation?.id) {
            actionReadyFired.current = false;
            prevConversationId.current = activeRemixConversation?.id;
        }
    }, [
        activeRemixConversation?.id
    ]);
    // Fire onActionReady when the appropriate message arrives:
    // - For whiteboard create/update: when the action is `streaming`.
    // - For all other actions: when ACTION_COMPLETE appears in chatMessages.
    (0, $42omo.useEffect)(()=>{
        if (actionReadyFired.current || !onActionReady) return;
        const whiteboardStreamingDetected = $1e31de274ed01603$var$hasWhiteboardRemixActionStreaming(chatMessages);
        const actionCompleteDetected = $1e31de274ed01603$var$isActionComplete(chatMessages);
        if (whiteboardStreamingDetected || actionCompleteDetected) {
            actionReadyFired.current = true;
            onActionReady();
        }
    }, [
        chatMessages,
        onActionReady
    ]);
    const stopRemixing = (0, $42omo.useCallback)(()=>{
        abortRequests?.({
            conversationId: activeRemixConversation?.id
        });
    }, [
        abortRequests,
        activeRemixConversation?.id
    ]);
    const openAIFCStagingModal = (0, $42omo.useCallback)((options)=>{
        setForceSkipAutoConversationSelection(true);
        // Open the Confluence Smart Creation Modal with stagingAreaActive=true
        // to skip the prompt screen and go straight to the staging area preview.
        //
        // Only keep the ephemeral preview for remix-generated preview content.
        // The shared helper currently treats dynamic UI, image-based remix flows,
        // and remix-generated whiteboards/diagrams as ephemeral-preview candidates.
        // All other ACTION_PREPARE results should open the full AIFC modal.
        //
        // Pass forceFullModal: true to bypass this check
        const shouldUseEphemeralPreview = options?.forceFullModal ? false : $1e31de274ed01603$var$shouldOpenEphemeralPreview(chatMessages);
        openModal({
            entryPoint: 'dynamicUi',
            spaceKey: spaceKey ?? undefined,
            parentContent: contentId && !isDraftPage ? {
                id: contentId,
                title: contentTitle ?? '',
                contentType: contentType ?? 'page'
            } : undefined,
            stagingAreaActive: true,
            isFloating: shouldUseEphemeralPreview,
            shouldShowBackButton: false,
            ...activeRemixConversation?.id && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) ? {
                remixConversationId: activeRemixConversation.id
            } : {},
            // `stagingAreaTargetMode` decides whether the current content is also
            // registered as staging-area content, or preserved only as parent/source
            // context for generated-content flows.
            ...stagingAreaTargetMode === 'current-content' && contentId ? {
                content: {
                    id: contentId,
                    type: contentType ?? 'page',
                    subType: isLivePage ? 'live' : null
                }
            } : {},
            // Pass a no-op submitCallback only for ephemeral (floating) previews to
            // prevent navigating away from the current page. For the full modal flow
            // (e.g. "Add to Confluence"), omit the callback so the default
            // handleSubmitSmartCreate handler runs and redirects to the newly created content.
            ...shouldUseEphemeralPreview ? {
                submitCallback: async ()=>{}
            } : {}
        });
    }, [
        openModal,
        spaceKey,
        contentId,
        contentType,
        contentTitle,
        isLivePage,
        isDraftPage,
        activeRemixConversation?.id,
        setForceSkipAutoConversationSelection,
        chatMessages,
        stagingAreaTargetMode
    ]);
    const sendAIFCPrompt = (0, $42omo.useCallback)(async ({ userPrompt: userPrompt, dynamicUiSubtype: dynamicUiSubtype, dynamicUiType: dynamicUiType, dynamicUiSource: dynamicUiSource, interactionSource: interactionSource, forcedContentType: forcedContentType })=>{
        const defaultPromptText = 'Remix the selected content';
        const selectedDisplayName = dynamicUiSubtype ? (0, $gCqjE.getSubTypeDisplayName)(dynamicUiSubtype) : (0, $gCqjE.getTypeDisplayName)(dynamicUiType);
        const promptText = dynamicUiType === 'custom' ? userPrompt ?? defaultPromptText : `Remix the selected content as a ${selectedDisplayName}`;
        // Build the ADF DocNode prompt.
        const prompt = {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: promptText
                        }
                    ]
                }
            ]
        };
        const newConversationId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        // Store the ID so we can identify this conversation as the active remix.
        setRemixConversationId(newConversationId);
        actionReadyFired.current = false;
        await createConversationOptimistically({
            id: newConversationId
        });
        // Send the message to Rovo
        sendMessage({
            prompt: prompt,
            storeUserMessages: preferences.storeUserMessages,
            conversationId: newConversationId,
            messageSources: {
                interactionSource: interactionSource,
                // Use the same source for follow-ups: Remix doesn't have a separate follow-up entry point, but the "viewed" AIMAU analytics event uses `followUpSource`.
                followUpSource: interactionSource
            },
            productKey: 'confluence',
            contentContext: 'staging-area',
            creationContextParams: {
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource,
                source: 'remix',
                ...forcedContentType ? {
                    forcedContentType: forcedContentType
                } : {}
            }
        });
        // Store the prompt text for display in the staging area header.
        // Always show "Remix" regardless of the user's custom prompt.
        setPrompt('Remix');
        // Persist the dynamic UI context so the update flow can use
        // the original type/source when sending remix adjustment messages
        setDynamicUiContext(dynamicUiType, dynamicUiSource);
    }, [
        createConversationOptimistically,
        sendMessage,
        setPrompt,
        setDynamicUiContext,
        preferences.storeUserMessages
    ]);
    return {
        sendAIFCPrompt: sendAIFCPrompt,
        stopRemixing: stopRemixing,
        isRemixError: isRemixError,
        remixStoreError: remixStoreError,
        openAIFCStagingModal: openAIFCStagingModal,
        closeAIFCStagingModal: closeModal,
        remixConversationId: remixConversationId,
        setSelectedConversation: setSelectedConversation
    };
};
module.exports["useRemixToAIFC"] = $1e31de274ed01603$export$cca9e2432f59b3f8;

});


//# sourceMappingURL=PageContentRendererFabric.bc907352.js.map
